import "./Description.scss";

const Description = (props) => {
  return <p className="description--1">{props.children}</p>;
};

export default Description;
